export const initialValues = {
  is_active: 1,
  title: "",
  qr_base_string: "",
  qr_size: null,
  qr_x: null,
  qr_y: null,
  desk_qr_size: null,
  desk_qr_x: null,
  desk_qr_y: null,
  // text_x: 0,
  // text_y: 0,
  image: null,
  is_show_member_id: 0,
};

export const updateInitialValues = {
  is_active: 1,
  title: "",
  image: "",
  is_show_member_id: 0,
  qr_base_string: "",
  qr_size: null,
  qr_x: null,
  qr_y: null,
  desk_qr_size: null,
  desk_qr_x: null,
  desk_qr_y: null,
  // text_x: 0,
  // text_y: 0,
};
